import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade } from "@mui/material";

import CustomSelect from "../../common/CustomSelect";

import { GetAppSettings, UpdateAppSetting } from "../../redux/appSettings/actions";

import "./style.css";

function Settings(props) {
    const [brgpfecs, setBrgpfecs] = useState(null);

    useEffect(() => {
        props.GetAppSettings();
    }, []);

    useEffect(() => {
        const brgpfecs = props.AppSettings?.list?.find((s) => s.tag === "brg-patient-follow-up-email-cron");
        setBrgpfecs(brgpfecs);
    }, [props.AppSettings?.count]);

    const hoursOfDay = [
        { label: "00:00", value: 0 },
        { label: "01:00", value: 1 },
        { label: "02:00", value: 2 },
        { label: "03:00", value: 3 },
        { label: "04:00", value: 4 },
        { label: "05:00", value: 5 },
        { label: "06:00", value: 6 },
        { label: "07:00", value: 7 },
        { label: "08:00", value: 8 },
        { label: "09:00", value: 9 },
        { label: "10:00", value: 10 },
        { label: "11:00", value: 11 },
        { label: "12:00", value: 12 },
        { label: "13:00", value: 13 },
        { label: "14:00", value: 14 },
        { label: "15:00", value: 15 },
        { label: "16:00", value: 16 },
        { label: "17:00", value: 17 },
        { label: "18:00", value: 18 },
        { label: "19:00", value: 19 },
        { label: "20:00", value: 20 },
        { label: "21:00", value: 21 },
        { label: "22:00", value: 22 },
        { label: "23:00", value: 23 }
    ];

    const handleSettingUpdate = (setting, value) => {
        props.UpdateAppSetting(setting, value);
    }

    return (
        <Fade in={true}>
            <div className="main-container" id="app-settings">
                <h4>App Settings</h4>
                <div className="row mt-5">
                    <div className="col-md-4">
                        <div id="brgp-fecs" className="form-group">
                            <label>{brgpfecs?.name}</label>
                            <CustomSelect value={brgpfecs?.value} options={hoursOfDay} onChange={(e) => {
                                handleSettingUpdate(brgpfecs, e.target?.value);
                            }} />
                        </div>
                    </div>
                </div>
            </div>
        </Fade>
    );
}

const mapStateToProps = (state) => ({
    AppSettings: state.AppSettings
})

export default connect(mapStateToProps, {
    GetAppSettings,
    UpdateAppSetting,
})(Settings);
